import type { Filters, MetricDataLevel } from '../types';

export const buildMetricCacheKey = (
  id: string,
  filters: Filters,
  mockApiFlag: boolean,
  revision: number,
  dataLevel: MetricDataLevel,
) =>
  `${id}:${filters.dealerId}:${filters.period.timePeriod}:${filters.period.startDate ?? ''}:${filters.period.endDate ?? ''}:level=${dataLevel}:mock=${mockApiFlag}:r${revision}`;
